export default __webpack_public_path__ + "static/media/sample.e4ae1ef3.jpg";